import { usageUnitLockPeriodStatusEnumList } from '../../../components/AgGrid/enumLists'

const usageUnitLockPeriodStatusValueGetter = (props) => {
  const { value } = props
  return usageUnitLockPeriodStatusEnumList(value)
}

export default usageUnitLockPeriodStatusValueGetter
